import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { ItemResponse, PortalCurrentUser } from '@proerp/shared';
import { portalRequest } from './apiClient';

export const PORTAL_ME_KEY = ['portal', 'me'] as const;

/**
 * Der angemeldete Partner-Zugang. Trägt auch die Freischaltungen
 * (`canSeeForecast`/`canSeeAssembly`) — die Navigation richtet sich danach.
 *
 * Wichtig: Das ist eine **Anzeige**-Entscheidung, keine Absicherung. Was ein
 * Partner tatsächlich abrufen darf, entscheidet der `PortalGuard` im Backend
 * (ADR 0085). Ein ausgeblendeter Menüpunkt ist kein Schutz.
 */
export function usePortalUser(options: { enabled?: boolean } = {}): UseQueryResult<PortalCurrentUser> {
  return useQuery({
    queryKey: PORTAL_ME_KEY,
    queryFn: async () => {
      const response = await portalRequest<ItemResponse<PortalCurrentUser>>('/me');
      return response.data;
    },
    enabled: options.enabled ?? true,
    // Kein Wiederholen: Ein 401/403 wird durch Warten nicht besser, und der
    // Nutzer soll die Anmeldung sofort sehen statt drei Anläufe abzuwarten.
    retry: false,
  });
}
